import React, {useEffect, useState} from "react";
import axios from "axios";
import _ from "lodash";
import PreviewStore from "./PreviewStore";
import {PRODUCT_SERVICE} from "../../clientConfig";
import {getInfoStore} from '../../clientServices/previewStore';

const PreCheck = (props) => {
  let [store, setStore] = useState({})
  useEffect(()=>{
    getInfoStore({
      code: window.location.hostname.split('.')[0].toUpperCase()
    })
    .then(function (response) {
      setStore(response.data)
    })
    .catch(function (error) {
      store = {}
    });
  }, [])
  return(<>
    <PreviewStore {...props} store={store}/>
  </>)
}
async function action(props)  {
  let store = {}
  if(props.params.id){
    await getInfoStore({
      code: props.params.id.toUpperCase()
    })
    .then((response) => {
      store = response.data
    })
    .catch((error) => {
      store = {}
    });
  }

  return {
    chunks: ["store"],
    component: _.isEmpty(store) ? <PreCheck {...props} store={store}/> : <PreviewStore {...props} store={store}/>,
  };
}

export default action;
